const RATE_LIMIT_STORAGE_PREFIX = "rate-limit:";

const readRateLimitState = (key) => {
  try {
    const rawValue = localStorage.getItem(`${RATE_LIMIT_STORAGE_PREFIX}${key}`);

    if (!rawValue) {
      return { timestamps: [], blockedUntil: 0 };
    }

    const parsedValue = JSON.parse(rawValue);

    return {
      timestamps: Array.isArray(parsedValue?.timestamps) ? parsedValue.timestamps : [],
      blockedUntil: Number(parsedValue?.blockedUntil) || 0,
    };
  } catch (error) {
    return { timestamps: [], blockedUntil: 0 };
  }
};

const writeRateLimitState = (key, state) => {
  localStorage.setItem(`${RATE_LIMIT_STORAGE_PREFIX}${key}`, JSON.stringify(state));
};

export const AUTH_RATE_LIMIT = {
  key: "auth-requests",
  windowMs: 15 * 60 * 1000,
  maxRequests: 15,
  message: "Too many authentication requests. Please try again later.",
};

export const getRateLimitStatus = (config) => {
  const now = Date.now();
  const state = readRateLimitState(config.key);
  const timestamps = state.timestamps.filter(
    (timestamp) => now - timestamp < config.windowMs
  );
  const blockedUntil = state.blockedUntil > now ? state.blockedUntil : 0;

  if (
    blockedUntil === 0 &&
    (timestamps.length !== state.timestamps.length || state.blockedUntil !== blockedUntil)
  ) {
    writeRateLimitState(config.key, { timestamps, blockedUntil });
  }

  return {
    blocked: blockedUntil > now || timestamps.length >= config.maxRequests,
    retryAfterMs:
      blockedUntil > now
        ? blockedUntil - now
        : timestamps.length >= config.maxRequests
          ? Math.max(0, config.windowMs - (now - timestamps[0]))
          : 0,
    timestamps,
    blockedUntil,
  };
};

export const consumeRateLimit = (config) => {
  const status = getRateLimitStatus(config);

  if (status.blocked) {
    return status;
  }

  const updatedTimestamps = [...status.timestamps, Date.now()];
  writeRateLimitState(config.key, {
    timestamps: updatedTimestamps,
    blockedUntil: status.blockedUntil,
  });

  return {
    blocked: false,
    retryAfterMs: 0,
    timestamps: updatedTimestamps,
    blockedUntil: status.blockedUntil,
  };
};

export const applyServerRateLimit = (config, retryAfterSeconds) => {
  const status = getRateLimitStatus(config);
  const retryAfterMs = Math.max(0, Number(retryAfterSeconds) || 0) * 1000;

  writeRateLimitState(config.key, {
    timestamps: status.timestamps,
    blockedUntil: retryAfterMs > 0 ? Date.now() + retryAfterMs : status.blockedUntil,
  });
};
